import React, { Children, lazy } from "react";
import Login from "./component/LoginComponents/newAuth/Login";
import AuthRootNew from "./component/LoginComponents/newAuth/AuthRootNew";
import ForgotPassword from "./component/LoginComponents/newAuth/ForgotPassword";
import VerifyOTP from "./component/LoginComponents/newAuth/VerifyOTP";
import NewPassword from "./component/LoginComponents/newAuth/NewPassword";
import ProgramNew from "./pages/ProgramNew";
import MasterclassCountdown from "./pages/MasterclassCountdown";
import Ats from "./pages/Ats";
import DownloadBrochures from "./pages/DownloadBrochures";
import { HomeCourse } from "./component/Home/Header";
import CustomPaymentPage from "./pages/CustomPaymentPage";
import AboutNew from "./pages/AboutNew";
import { MockTestInterface } from "./pages/MockTestInterface_Neo";
import AtsPublic from "./pages/AtsPublic";
import AtsSecure from "./pages/AtsSecure";
import Tests from "./pages/Tests";
import MentorApplicationForm from "./pages/MentorApplicationForm";
import JobsPortalNeo from "./pages/JobsPortalNeo";
import Jobs from "./pages/Jobs";
import JobDetails from "./component/Job/JobDetails";
import { CompanyDashboard } from "./pages/CompanyDashboard";
import { CompanyInit } from "./pages/CompanyInit";
import { CompanyPortalLanding } from "./pages/CompanyPortalLanding";

const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const ApplicationSubmit = lazy(() => import("./pages/ApplicationSubmit"));
const Apply = lazy(() => import("./pages/Apply"));
const Blogdescription = lazy(() => import("./pages/Blogdescription"));
const Blogs = lazy(() => import("./pages/Blogs"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const JobDescription = lazy(() => import("./pages/JobDescription"));
const MeetOurTeam = lazy(() => import("./pages/MeetOurTeam"));
const Mentors = lazy(() => import("./pages/Mentors"));
const OurJobs = lazy(() => import("./pages/OurJobs"));
const OurPolicy = lazy(() => import("./pages/OurPolicy"));
const PlacedCandidate = lazy(() => import("./pages/PlacedCandidate"));
const StudyAndInternship = lazy(() => import("./pages/StudyAndInternship"));
const TestimonialVideo = lazy(() => import("./pages/TestimonialVideo"));
const WhatTestimonies = lazy(() => import("./pages/WhatTestimonies"));
const Program = lazy(() => import("./pages/Program"));
const BecomeInstructor = lazy(() => import("./pages/BecomeInstructor"));
const HireUs = lazy(() => import("./pages/HireUs"));
const TermsAndCondition = lazy(() => import("./pages/TermsAndCondition"));
const RefundPolicy = lazy(() => import("./pages/RefundPolicy"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const EnrollNow = lazy(() => import("./pages/EnrollNow"));
const ThankYou = lazy(() => import("./pages/ThankYou"));
const DashBoardRoot = lazy(() => import("./pages/DashBoardRoot"));
const Bootcamp = lazy(() => import("./pages/Bootcamp"));
const AuthRootPage = lazy(() => import("./pages/AuthRootPage"));
const EnrollPage = lazy(() => import("./pages/EnrollPage"));
const Masterclass = lazy(() => import("./pages/Masterclass"));
const Test = lazy(() => import("./pages/Test"));
// const BlogDashboardRoot = lazy(()=>import("./pages/BlogDashboardRoot"))
const BlogDashBoard = lazy(() => import("./pages/BlogDashBoard"));
const BlogDashboardRegister = lazy(() =>
  import("./pages/BlogDashboardRegister")
);
const BlogSignUp = lazy(() => import("./pages/BlogSignup"));
const BlogOtp = lazy(() => import("./pages/BlogOtp"));
const CertificateInfo = lazy(() => import("./pages/CertificateInfo"));

const RoutesArr = [
  {
    name: "Home",
    path: "/",
    key: "Home",
    route: "/",
    page: <Home />,
  },
  {
    name: "Mock Test",
    path: "/mock-test",
    key: "Mock Test",
    route: "/mock-test",
    page: <MockTestInterface />,
  },
  {
    name: "About",
    path: "/about",
    key: "About",
    route: "/about",
    page: <AboutNew />,
  },
  {
    name: "Custom Payment ",
    path: "/payments/custom-payment",
    key: "About",
    route: "/payments/custom-payment",
    page: <CustomPaymentPage />,
  },
  {
    name: "Our Programs",
    path: "/programs",
    key: "Our Programs",
    route: "/programs",
    page: <HomeCourse />,
  },
  {
    name: "Download Brochures",
    path: "/download-brochures",
    key: "Download Brochures",
    route: "/download-brochures",
    page: <DownloadBrochures />,
  },
  {
    name: "Resume ATS Score Checker",
    path: "/evaluate-your-resume",
    key: "Resume ATS Score Checker",
    route: "/evaluate-your-resume",
    page: <AtsPublic />,
  },
  {
    name: "Jobs Portal Metbrains",
    path: "/jobs-portal",
    key: "Jobs Portal Metbrains",
    route: "/jobs-portal",
    page: <JobsPortalNeo />,
  },
  // {
  //   name: "Masterclass Link",
  //   path: "/na6nsd/masterclass-link",
  //   key: "Masterclass Link",
  //   route: "/na6nsd/masterclass-link",
  //   page: <MasterclassCountdown />,
  // },

  // {
  //   name: "MeetOurTeam",
  //   path: "/meet-our-team",
  //   key: "MeetOurTeam",
  //   route: "/meet-our-team",
  //   page: <MeetOurTeam />,
  // },

  // {
  //   name: "job-description",
  //   path: "/job-description/:id",
  //   key: "job-description",
  //   route: "/job-description",
  //   page: <JobDescription />,
  // },
  // {
  //   name: "application-submit",
  //   path: "/application-submit",
  //   key: "application-submit",
  //   route: "/application-submit",
  //   page: <ApplicationSubmit />,
  // },
  {
    name: "contact-us",
    path: "/contact-us",
    key: "contact-us",
    route: "/contact-us",
    page: <ContactUs />,
  },
  {
    name: "our-policy",
    path: "/our-policy",
    key: "our-policy",
    route: "/our-policy",
    page: <OurPolicy />,
  },
  {
    name: "blogs",
    path: "/blogs",
    key: "blogs",
    route: "/blogs",
    page: <Blogs />,
  },
  // Blogs sections can be ignored
  {
    name: "blog-description",
    path: "/blog-description/:id",
    key: "blog-description",
    route: "/blog-description/:id",
    page: <Blogdescription />,
  },
  {
    name: "blog-preview",
    path: "/blog-preview/:id",
    key: "blog-preview",
    route: "/blog-preview/:id", // blog-preview ccan be ignored
    page: <Blogdescription />,
  },

  // {
  //   name: "testimonial-video",
  //   path: "/testimonial-video",
  //   key: "testimonial-video",
  //   route: "/testimonial-video",
  //   page: <TestimonialVideo />,
  // },
  // {
  //   name: "mentors",
  //   path: "/mentors",
  //   key: "mentors",
  //   route: "/mentors",
  //   page: <Mentors />,
  // },
  {
    name: "placed-candidates",
    path: "/placed-candidates",
    key: "placed-candidates",
    route: "/placed-candidates",
    page: <WhatTestimonies />,
  },
  {
    name: "reviews",
    path: "/reviews",
    key: "reviews",
    route: "/reviews",
    page: <PlacedCandidate />,
  },
  // {
  //   name: "study-and-internship",
  //   path: "/study-and-internship",
  //   key: "study-and-internship",
  //   route: "/study-and-internship",
  //   page: <StudyAndInternship />,
  // },

  // {
  //   name: "mgtip",
  //   path: "/mgtip",
  //   key: "mgtip",
  //   route: "/mgtip",
  //   page: <StudyAndInternship />,
  // },
  // {
  //   name: "apply",
  //   path: "/apply",
  //   key: "apply",
  //   route: "/apply",
  //   page: <Apply />,
  // },
  // {
  //   name: "virtual-internship-experiance",
  //   path: "/virtual-internship-experiance",
  //   key: "virtual-internship-experiance",
  //   route: "/virtual-internship-experiance",
  //   page: <TestimonialVideo />,
  // },
  {
    name: "placed-testimonies",
    path: "/placed-testimonies",
    key: "placed-testimonies",
    route: "/placed-testimonies",
    page: <PlacedCandidate />,
  },

  {
    name: "certification",
    path: "/certification/:id",
    key: "certification",
    route: "/certification",
    page: <Program />,
  },
  {
    name: "program",
    path: "/:id",
    key: "program",
    route: "/:id",
    page: <Program />,
  },
  {
    name: "program",
    path: "/:id/:name",
    key: "program",
    route: "/:id/:name",
    page: <Program />,
  },
  {
    name: "mentor-application-form",
    path: "/mentor-application-form",
    key: "mentor-application-form",
    route: "/mentor-application-form",
    page: <MentorApplicationForm />,
  },
  // {
  //   name: "become-instructor",
  //   path: "/become-instructor",
  //   key: "become-instructor",
  //   route: "/become-instructor",
  //   page: <BecomeInstructor />,
  // },
  // {
  //   name: "hire-us",
  //   path: "/hire-us",
  //   key: "hire-us",
  //   route: "/hire-us",
  //   page: <HireUs />,
  // },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    key: "terms-and-conditions",
    route: "/terms-and-conditions",
    page: <TermsAndCondition />,
  },
  {
    name: "refund-policy",
    path: "/refund-policy",
    key: "refund-policy",
    route: "/refund-policy",
    page: <RefundPolicy />,
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    key: "privacy-policy",
    route: "/privacy-policy",
    page: <PrivacyPolicy />,
  },
  {
    name: "thank-you",
    path: "/thank-you/:date/:currency/:value",
    key: "thank-you",
    route: "/thank-you/:date/:currency/:value",
    page: <ThankYou />,
  },
  {
    name: "company-dashboard",
    path: "/company-dashboard",
    key: "company-dashboard",
    route: "/company-dashboard",
    page: <CompanyDashboard />,
    private: false,
  },
  {
    name: "company-portal",
    path: "/company-portal",
    key: "company-portal",
    route: "/company-portal",
    page: <CompanyPortalLanding />,
    private: false,
  },
  {
    name: "company-portal-register",
    path: "/company-portal/register",
    key: "company-portal-register",
    route: "/company-portal/register",
    page: <CompanyInit />,
    private: false,
  },
  {
    name: "dashboard",
    path: "/dashboard/",
    key: "dashboard",
    route: "/dashboard/",
    page: <DashBoardRoot />,
    private: true,
  },
  {
    name: "dashboard-course",
    path: "/dashboard/course",
    key: "dashboard-course",
    route: "/dashboard/course",
    page: <DashBoardRoot />,
    private: true,
  },
  {
    name: "dashboard-achievement",
    path: "/dashboard/achievement",
    key: "dashboard-achievement",
    route: "/dashboard/achievement",
    page: <DashBoardRoot />,
    private: true,
  },
  {
    name: "dashboard-course-id",
    path: "/dashboard/course/:id",
    key: "dashboard-course-id",
    route: "/:id",
    page: <DashBoardRoot />,
    private: true,
  },
  {
    name: "dashboard-projects",
    path: "/dashboard/projects",
    key: "dashboard-projects",
    route: "/dashboard/projects",
    page: <DashBoardRoot />,
    private: true,
  },
  {
    name: "dashboard-schedule",
    path: "/dashboard/schedule",
    key: "dashboard-schedule",
    route: "/dashboard/schedule",
    page: <DashBoardRoot />,
    private: true,
  },
  {
    name: "dashboard-profile",
    path: "/dashboard/profile",
    key: "dashboard-profile",
    route: "/dashboard/profile",
    page: <DashBoardRoot />,
    private: true,
  },
  {
    name: "/dashboard/support",
    path: "/dashboard/support",
    key: "/dashboard/support",
    route: "/dashboard/support",
    page: <DashBoardRoot />,
    private: true,
  },

  {
    name: "/dashboard/course/overview-modules",
    path: "/dashboard/course/overview-modules",
    key: "/dashboard/course/overview-modules",
    route: "/dashboard/course/overview-modules",
    page: <DashBoardRoot />,
    private: true,
  },

  {
    name: "/dashboard/course/video/:id/:type",
    path: "/dashboard/course/video/:id/:type",
    key: "/dashboard/course/video/:id/:type",
    route: "/dashboard/course/video/:id/:type",
    page: <DashBoardRoot />,
    private: true,
  },

  {
    name: "/dashboard/projects/list",
    path: "/dashboard/projects/list",
    key: "/dashboard/projects/list",
    route: "/dashboard/projects/list",
    page: <DashBoardRoot />,
    private: true,
  },
  {
    name: "/dashboard/projects/list/:id",
    path: "/dashboard/projects/list/:id",
    key: "/dashboard/projects/list/:id",
    route: "/dashboard/projects/list/:id",
    page: <DashBoardRoot />,
    private: true,
  },

  {
    name: "/dashboard/profile/edit",
    path: "/dashboard/profile/edit",
    key: "/dashboard/profile/edit",
    route: "/dashboard/profile/edit",
    page: <DashBoardRoot />,
    private: true,
  },
  {
    name: "/dashboard/profile/change-password",
    path: "/dashboard/profile/change-password",
    key: "/dashboard/profile/change-password",
    route: "/dashboard/profile/change-password",
    page: <DashBoardRoot />,
    private: true,
  },
  // {
  //   name: "bootcamps",
  //   path: "/bootcamps",
  //   key: "bootcamps",
  //   route: "/bootcamps",
  //   page: <Bootcamp />,
  // },
  // {
  //   name: "bootcamp",
  //   path: "/bootcamp",
  //   key: "bootcamp",
  //   route: "/bootcamp",
  //   page: <Bootcamp />,
  // },

  // {
  //   name: "oyip",
  //   path: "/oyip",
  //   key: "oyip",
  //   route: "/oyip",
  //   page: <Bootcamp />,
  // },
  {
    name: "login",
    path: "/login",
    key: "login",
    route: "/login",
    page: <AuthRootNew />,
    children: [
      {
        name: "indexlogin",
        path: "",
        index: true,
        key: "index-login",
        page: <Login />,
      },
      {
        name: "companyIndexlogin",
        path: "company",
        index: true,
        key: "company-index-login",
        page: <Login />,
      },
      {
        name: "forgot-password",
        path: "forgot-password",
        key: "forgot-password",
        route: "forgot-password",
        page: <ForgotPassword />,
      },
    ],
  },
  // {
  //   name: "verify-otp",
  //   path: "/verify-otp",
  //   key: "verify-otp",
  //   route: "/verify-otp",
  //   page: <AuthRootPage />,
  // },
  {
    name: "enroll-now",
    path: "/enroll-now/:type/:id",
    key: "enroll-now",
    route: "/enroll-now/:type/:id",
    page: <EnrollPage />,
  },
  {
    name: "cybercamp",
    path: "/cybercamp/:slug",
    key: "cybercamp",
    route: "/cybercamp/:slug",
    page: <Masterclass />,
  },
  {
    name: "datacamp",
    path: "/datacamp/:slug",
    key: "datacamp",
    route: "/datacamp/:slug",
    page: <Masterclass />,
  },
  {
    name: "masterclass",
    path: "/masterclass/:slug",
    key: "masterclass",
    route: "/masterclass/:slug",
    page: <Masterclass />,
  },
  {
    name: "blog-dashboard",
    path: "/blog-dashboard",
    key: "blog-dashboard",
    route: "/blog-dashboard",
    page: <BlogDashBoard />,
  },
  {
    name: "blog-dashboard-update-profile",
    path: "/blog-dashboard/update-profile",
    key: "blog-dashboard/update-profile",
    route: "/blog-dashboard/update-profile",
    page: <BlogDashBoard />,
  },
  {
    name: "blog-dashboard-update-password",
    path: "/blog-dashboard/update-password",
    key: "blog-dashboard/update-password",
    route: "/blog-dashboard/update-password",
    page: <BlogDashBoard />,
  },
  {
    name: "blog-dashboard-profile",
    path: "/blog-dashboard/profile",
    key: "blog-dashboard/profile",
    route: "/blog-dashboard/profile",
    page: <BlogDashBoard />,
  },
  {
    name: "blog-dashboard-profile-submitted",
    path: "/blog-dashboard/profile/submitted",
    key: "blog-dashboard/profile/submitted",
    route: "/blog-dashboard/profile/submitted",
    page: <BlogDashBoard />,
  },
  {
    name: "blog-dashboard-edit-blog",
    path: "/blog-dashboard/edit-blog/:id",
    key: "blog-dashboard-edit-blog",
    route: "/blog-dashboard/edit-blog/:id",
    page: <BlogDashBoard />,
  },
  {
    name: "blog-dashboard-profile-published",
    path: "/blog-dashboard/profile/published",
    key: "blog-dashboard/profile/published",
    route: "/blog-dashboard/profile/published",
    page: <BlogDashBoard />,
  },
  {
    name: "blog-dashboard-home-submitted",
    path: "/blog-dashboard/home/submitted",
    key: "blog-dashboard/home/submitted",
    route: "/blog-dashboard/home/submitted",
    page: <BlogDashBoard />,
  },
  {
    name: "blog-dashboard-home-published",
    path: "/blog-dashboard/home/published",
    key: "blog-dashboard/home/published",
    route: "/blog-dashboard/home/published",
    page: <BlogDashBoard />,
  },
  {
    name: "blog-dashboard-choose-domain",
    path: "/blog-dashboard/create-blog",
    key: "blog-dashboard/choose-domain",
    route: "/blog-dashboard/create-blog",
    page: <BlogDashBoard />,
  },
  {
    name: "blog-dashboard-upload-thumb",
    path: "/blog-dashboard/upload-thumb",
    key: "blog-dashboard/upload-thumb",
    route: "/blog-dashboard/upload-thumb",
    page: <BlogDashBoard />,
  },

  {
    name: "blog-dashboard-insert-content",
    path: "/blog-dashboard/insert-content",
    key: "blog-dashboard/insert-content",
    route: "/blog-dashboard/insert-content",
    page: <BlogDashBoard />,
  },

  {
    name: "blog-register",
    path: "/blog-register",
    key: "/blog-register",
    route: "/blog-register",
    page: <BlogDashboardRegister />,
  },

  {
    name: "blog-dashboard/home",
    path: "/blog-dashboard/home",
    key: "blog-dashboard/home",
    route: "/blog-dashboard/home",
    page: <BlogDashBoard />,
  },

  {
    name: "blog-signup",
    path: "/blog-signup",
    key: "blog-signup",
    route: "/blog-signup",
    page: <BlogSignUp />,
  },

  {
    name: "blog-otp",
    path: "/blog-otp",
    key: "blog-otp",
    route: "/blog-otp",
    page: <BlogOtp />,
  },
  {
    name: "user-accounts",
    path: "/user-accounts",
    key: "user-accounts",
    route: "/user-accounts",
    page: <AuthRootPage />,
  },
  // {
  //   name: "certificate-preview",
  //   path: "/certificate-preview/:id",
  //   key: "certificate-preview",
  //   route: "/certificate-preview/:id",
  //   page: <CertificateInfo />,
  // },
  {
    name: "/dashboard/ticket",
    path: "/dashboard/ticket",
    key: "/dashboard/ticket",
    route: "/dashboard/ticket",
    page: <DashBoardRoot />,
    private: true,
  },
  {
    name: "/dashboard/ats-score-check",
    path: "/dashboard/ats-score-check",
    key: "/dashboard/ats-score-check",
    route: "/dashboard/ats-score-check",
    page: <DashBoardRoot />,
    private: true,
  },

  {
    name: "/dashboard/ticket/:id",
    path: "/dashboard/ticket/:id",
    key: "/dashboard/ticket/:id",
    route: "/dashboard/ticket/:id",
    page: <DashBoardRoot />,
    private: true,
  },
  {
    name: "/dashboard/plans-billings",
    path: "/dashboard/plans-billings",
    key: "/dashboard/plans-billings",
    route: "/dashboard/plans-billings",
    page: <DashBoardRoot />,
    private: true,
  },
  {
    name: "/dashboard/resources",
    path: "/dashboard/resources",
    key: "/dashboard/resources",
    route: "/dashboard/resources",
    page: <DashBoardRoot />,
    private: true,
  },
  {
    name: "/dashboard/resource-detail",
    path: "/dashboard/resource-detail/:id",
    key: "/dashboard/resource-detail/:id",
    route: "/dashboard/resource-detail/:id",
    page: <DashBoardRoot />,
    private: true,
  },

  {
    name: "/dashboard/resource-detail-type",
    path: "/dashboard/resource-detail/:id/:type",
    key: "/dashboard/resource-detail-type",
    route: "/dashboard/resource-detail/:id/:type",
    page: <DashBoardRoot />,
    private: true,
  },

  {
    name: "/dashboard/resource-view",
    path: "/dashboard/resource-view/:id",
    key: "/dashboard/resource-view/",
    route: "/dashboard/resource-view/:id",
    page: <DashBoardRoot />,
    private: true,
  },
  {
    name: "/ats",
    path: "/ats",
    key: "/ats",
    route: "/ats",
    page: <AtsSecure />,
    private: false,
  },
  {
    name: "/test",
    path: "/test",
    key: "/test",
    route: "/test",
    page: <Tests />,
    private: false,
  },

  {
    name: "/jobs",
    path: "/jobs",
    key: "/jobs",
    route: "/jobs",
    page: <Jobs />,
    private: false,
  },
  {
    name: "/job/:id/:slug",
    path: "/job/:id/:slug",
    key: "/job/:id/:slug",
    route: "/job/:id/:slug",
    page: <JobDetails />,
    private: false,
  },
];

export default RoutesArr;
